module.exports = __webpack_public_path__ + "static/media/Curoflow_Digital_Telemedicine_Platform_Icon.2dcda82e.png";